import { ODPProjectWorkflowViewModel } from './odpprojectworkflow/odpProjectWorkflow.model';
import { TeamSelectionViewModel } from "./team/team.model";

export class User {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(id?: string, userName?: string, fullName?: string, firstName?: string, lastName?: string, email?: string, jobTitle?: string, phoneNumber?: string, roles?: string[], projects?: ODPProjectWorkflowViewModel[], teams?: TeamSelectionViewModel[], activeRole?: any, activeProject?: ODPProjectWorkflowViewModel, activeTeam?: TeamSelectionViewModel, activeValsSelected?: boolean, lastLoginDateString?: string) {

    this.id = id;
    this.userName = userName;
    this.fullName = fullName;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.jobTitle = jobTitle;
    this.phoneNumber = phoneNumber;
    this.roles = roles ? roles : new Array();
    this.projects = projects ? projects : new Array();
    this.teams = teams ? teams : new Array();
    this.activeRole = activeRole;
    this.activeProject = activeProject;
    this.activeTeam = activeTeam;
    this.activeValsSelected = activeValsSelected;
    this.lastLoginDateString = lastLoginDateString;
  }


  get friendlyName(): string {
    let name = this.fullName || this.userName;

    if (this.jobTitle)
      name = this.jobTitle + " " + name;

    return name;
  }


  public id: string;
  public userName: string;
  public fullName: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public password: string;
  public jobTitle: string;
  public phoneNumber: string;
  public isEnabled: boolean;
  public isLockedOut: boolean;
  public roles: string[];
  public teams: TeamSelectionViewModel[];
  public projects: ODPProjectWorkflowViewModel[];
  public activeRole: any;
  public activeProject: ODPProjectWorkflowViewModel;
  public activeTeam: TeamSelectionViewModel;
  public activeValsSelected: boolean;
  public lastLoginDateString: string;
}
